import { Image, Text, View, StyleSheet, Font } from "@react-pdf/renderer";
import React from "react";
import { ApplicationJSON } from "../../schemas/applications/ApplicationJSON";
import ActiveApplication from "../../schemas/applications/ActiveApplication";
import { ProjectJSON } from "../../schemas/projects/ProjectJSON";

Font.register({
  family: "Roboto",
  fonts: [
    { src: "/fonts/roboto/Roboto-Regular.ttf", fontStyle: "normal" },
    { src: "/fonts/roboto/Roboto-Italic.ttf", fontStyle: "italic" },
    {
      src: "/fonts/roboto/Roboto-Thin.ttf",
      fontStyle: "normal",
      fontWeight: "thin",
    },
    {
      src: "/fonts/roboto/Roboto-ThinItalic.ttf",
      fontStyle: "italic",
      fontWeight: "thin",
    },
    {
      src: "/fonts/roboto/Roboto-Light.ttf",
      fontStyle: "normal",
      fontWeight: "light",
    },
    {
      src: "/fonts/roboto/Roboto-LightItalic.ttf",
      fontStyle: "italic",
      fontWeight: "light",
    },
    {
      src: "/fonts/roboto/Roboto-Light.ttf",
      fontStyle: "normal",
      fontWeight: "light",
    },
    {
      src: "/fonts/roboto/Roboto-LightItalic.ttf",
      fontStyle: "italic",
      fontWeight: "light",
    },
    {
      src: "/fonts/roboto/Roboto-Medium.ttf",
      fontStyle: "normal",
      fontWeight: "medium",
    },
    {
      src: "/fonts/roboto/Roboto-MediumItalic.ttf",
      fontStyle: "italic",
      fontWeight: "medium",
    },
    {
      src: "/fonts/roboto/Roboto-Bold.ttf",
      fontStyle: "normal",
      fontWeight: "bold",
    },
    {
      src: "/fonts/roboto/Roboto-BoldItalic.ttf",
      fontStyle: "italic",
      fontWeight: "bold",
    },
    {
      src: "/fonts/roboto/Roboto-Black.ttf",
      fontStyle: "normal",
      fontWeight: "heavy",
    },
    {
      src: "/fonts/roboto/Roboto-BlackItalic.ttf",
      fontStyle: "italic",
      fontWeight: "heavy",
    },
  ],
});
Font.registerHyphenationCallback((word) => [word]);

const styles = StyleSheet.create({
  headerContainer: {
    width: "100%",
    fontFamily: "Roboto",
    position: "relative",
  },
  // Top header box with blue border
  topHeaderBox: {
    width: "100%",
    border: "#0090c9",
    borderWidth: 3,
    borderRadius: 8,
    flexDirection: "row",
  },
  // Left side of top header
  topHeaderLeft: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    padding: 4,
  },
  logoSection: {
    width: "3in",
  },
  logo: {
    width: "2.8in",
    fontSize: "20",
  },
  logoText: {
    fontSize: 9,
    color: "#666",
  },
  titleSection: {
    flex: 1,
    marginLeft: "3%",
  },
  mainTitle: {
    fontSize: 18,
    fontWeight: "bold",
    textAlign: "left",
    marginBottom: 5,
  },
  rowContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    flex: 1,
  },

  leftColumn: {
    marginRight: 20,
    maxWidth: "43%",
  },

  rightColumn: {
    maxWidth: "44%",
  },

  fromText: {
    fontSize: 14,
  },

  dateText: {
    fontSize: 11,
    lineHeight: 1.3,
  },

  row: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 2,
  },

  label: {
    marginRight: 2,
    fontSize: 11,
    color: "#000",
  },

  value: {
    fontSize: 11,
    fontWeight: "bold",
  },

  // Right side of top header (light blue background)
  topHeaderRight: {
    width: 200,
    backgroundColor: "#b8d4ea",
    justifyContent: "center",
    alignItems: "center",
    borderLeft: "#0090c9",
    borderLeftWidth: 1,
  },
  applicationLabel: {
    fontSize: 12,
    fontWeight: "heavy",
    marginBottom: 2,
  },
  applicationNumber: {
    fontSize: 30,
    fontWeight: "heavy",
    marginBottom: 3,
  },
  developByContainer: {
    alignItems: "center",
    justifyContent: "center",
  },
  singleLineText: {
    fontSize: 11,
    flexWrap: "nowrap",
  },

  // Project info section (always visible)
  projectSection: {
    width: "100%",
    borderBottomColor: "#0090c9",
    borderBottomWidth: 3,
    position: "relative",
    padding: 6,
  },

  projectHeader: {
    fontSize: 20,
    fontWeight: "bold",
    marginBottom: 8,
    marginTop: 4,
  },
  projectInfoRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  projectInfoItem: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
  },
  projectLabel: {
    fontSize: 14,
    fontWeight: "bold",
    width: 70,
    marginRight: 10,
  },
  projectValue: {
    fontSize: 14,
    flex: 1,
  },
  // Full contractor section (only for application)
  contractorSection: {
    width: "100%",
    borderBottomColor: "#0090c9",
    borderBottomWidth: 3,
    flexDirection: "row",
    minHeight: 120,
    padding: 6,
  },
  contractorColumn: {
    flex: 1,
    paddingHorizontal: 6,
    borderRight: "#0090c9",
    borderRightWidth: 2,
  },
  contractorColumnLast: {
    flex: 1,
    paddingHorizontal: 6,
  },
  contractorHeader: {
    fontSize: 20,
    fontWeight: "bold",
    marginBottom: 3,
    textAlign: "left",
  },
  infoRow: {
    flexDirection: "row",
    marginBottom: 3,
    alignItems: "flex-start",
  },
  infoLabel: {
    fontSize: 13,
    fontWeight: "bold",
    width: 70,
    marginRight: 10,
  },
  infoValue: {
    fontSize: 13,
    flex: 1,
  },
  // Type legend for change orders
  typeInfo: {
    display: "flex",
    alignItems: "center",
    fontSize: 14,
    flexDirection: "row",
    marginLeft: 10,
    marginTop: 5,
  },
  typeLegendTitle: {
    fontWeight: "bold",
    marginBottom: 2,
    marginTop: 4,
    color: "#008000",
  },
  typeLegendAesterick: {
    fontWeight: "bold",
    fontSize: 20,
    marginBottom: 2,
    marginTop: 4,
    color: "#008000",
  },
  typeLegendItem: {
    marginLeft: 2,
    color: "#008000",
  },
  pageNumber: {
    fontSize: 16,
  },
});

const addSpaceAfter = (text: string | undefined | null, maxWidth: number = 33): string => {
  if (!text) return "";
  
  // Character width weights (approximate relative widths for Roboto font)
  const charWeights: { [key: string]: number } = {
    'W': 1.60, 'M': 1.58, 'Q': 1.28, 'D': 1.18, 'O': 1.28, 'G': 1.20, 'C': 1.18,
    'H': 1.30, 'N': 1.32, 'U': 1.18, 'B': 1.12, 'K': 1.12, 'R': 1.12, 'P': 1.12,
    'A': 1.18, 'V': 1.12, 'X': 1.12, 'Y': 1.1, 'Z': 1.1, 'T': 1.1, 'S': 1.08,
    'E': 1.02, 'F': 1, 'L': 1.02, 'I': 0.52,
    'c': 0.95, 'd': 1.05, 'e': 0.98, 'i': 0.48, 'k': 0.92, 'l': 0.48, 'm': 1.58,
    'n': 1.02, 'o': 1.05, 'q': 1.05, 'j': 0.48, 'f': 0.68, 't': 0.6,
    'v': 0.88, 'w': 1.38, 'x': 0.9, 'y': 0.88, 's': 0.95, 'z': 0.9, 'r': 0.62, 
    ' ': 0.52, '.': 0.5, '_': 0.82, '-': 0.52, ',': 0.38, '@': 1.6, '#': 1.12, 
    '%': 1.32, '*': 0.82, ':': 1.02, '&': 1.12, '?': 0.88, '+': 1.08
  };
  
  // Helper function to calculate width of a string
  const calculateWidth = (str: string): number => {
    let width = 0;
    for (let i = 0; i < str.length; i++) {
      width += charWeights[str[i]] || 1.0;
    }
    return width;
  };
  
  // Helper function to check if a word is "small" (3 or fewer characters)
  const isSmallWord = (word: string): boolean => {
    return word.length <= 3;
  };
  
  let totalWidth = 0;
  let breakIndex = 0;
  
  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    const weight = charWeights[char] || 1.0;
    totalWidth += weight;
    
    if (totalWidth > maxWidth) {
      breakIndex = i;
      break;
    }
  }
  
  // If text fits within width, return as-is
  if (breakIndex === 0) return text;
  
  // Check if we're about to break a small word
  // Look backward to find the start of the current word
  let wordStart = breakIndex;
  while (wordStart > 0 && text[wordStart - 1] !== ' ') {
    wordStart--;
  }
  
  // Look forward to find the end of the current word
  let wordEnd = breakIndex;
  while (wordEnd < text.length && text[wordEnd] !== ' ') {
    wordEnd++;
  }
  
  const currentWord = text.substring(wordStart, wordEnd);
  
  // If it's a small word being broken, move the entire word to next line
  if (isSmallWord(currentWord) && wordStart > 0) {
    // Break before the small word (at the space before it)
    return text.substring(0, wordStart) + '\n' + text.substring(wordStart);
  }
  
  // For longer words, break at the calculated position
  return text.substring(0, breakIndex) + '\n' + text.substring(breakIndex);
};

// Helper function to intelligently truncate text based on character width estimation
const smartTruncate = (text: string | undefined | null, maxWidth: number): string => {
  if (!text) return "";
  
  // Character width weights (approximate relative widths for Roboto font)
  const charWeights: { [key: string]: number } = {
    'W': 1.60, 'M': 1.58, 'Q': 1.28, 'D': 1.18, 'O': 1.28, 'G': 1.20, 'C': 1.18,
    'H': 1.30, 'N': 1.32, 'U': 1.18, 'B': 1.12, 'K': 1.12, 'R': 1.12, 'P': 1.12,
    'A': 1.18, 'V': 1.12, 'X': 1.12, 'Y': 1.1, 'Z': 1.1, 'T': 1.1, 'S': 1.08,
    'E': 1.02, 'F': 1, 'L': 1.02, 'I': 0.52,
    'c': 0.95, 'd': 1.05, 'e': 0.98, 'i': 0.48, 'k': 0.92, 'l': 0.48, 'm': 1.58,
    'n': 1.02, 'o': 1.05, 'q': 1.05, 'j': 0.48, 'f': 0.68, 't': 0.6,
    'v': 0.88, 'w': 1.38, 'x': 0.9, 'y': 0.88, 's': 0.95, 'z': 0.9, 'r': 0.62, 
    ' ': 0.52, '.': 0.5, '_': 0.82, '-': 0.52, ',': 0.38, '@': 1.6, '#': 1.12, 
    '%': 1.32, '*': 0.82, '$': 1.02, '&': 1.12, '?': 0.88, '+': 1.08
  };
  
  let totalWidth = 0;
  let cutIndex = 0;
  
  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    const weight = charWeights[char] || 1.0; // Default weight for unlisted chars
    totalWidth += weight;
    
    if (totalWidth > maxWidth) {
      cutIndex = i;
      break;
    }
  }
  
  // If we went through the whole string without exceeding, return it as-is
  if (cutIndex === 0) return text;
  
  // Otherwise truncate and add ellipsis, leave some buffer
  return text.substring(0, Math.max(1, cutIndex - 2)) + "…";
};


export function PDFHeader(
  applicationJSON: ApplicationJSON,
  projectJSON: ProjectJSON,
  pdfType: "application" | "continuation" | "changeOrder",
  customStyles: any = {},
  logo?: { url: string; width: number; height: number } | undefined
): React.ReactElement {
  const application = new ActiveApplication(applicationJSON);

  // Format dates
  const originalApplicationDate = application!.applicationDate as string;
  const applicationDate =
    originalApplicationDate.substr(5, 2) +
    "/" +
    originalApplicationDate.substr(8, 2) +
    "/" +
    originalApplicationDate.substr(0, 4);
  const originalPeriodTo = application!.periodTo as string;
  const periodTo =
    originalPeriodTo.substr(5, 2) +
    "/" +
    originalPeriodTo.substr(8, 2) +
    "/" +
    originalPeriodTo.substr(0, 4);

  // Get page title based on type
  const getPageTitle = () => {
    console.log(pdfType);

    switch (pdfType) {
      case "application":
        return "Application & Certificate for Payment";
      case "continuation":
        return "Continuation Sheet";
      case "changeOrder":
        return "Change Orders";
      default:
        return "Application & Certificate for Payment";
    }
  };

  const getTitleStyle = () => {
    if (pdfType === "changeOrder") {
      return { ...styles.mainTitle, color: "#FF0000" };
    }
    return styles.mainTitle;
  };

  
  // Only show full contractor info for application type
  const showFullContractorInfo = pdfType === "application";

  // if (logo) {
  //   console.log(logo, "logo");
  //   let width = (logo.width / logo.height) * 1;
  //   if (width > 3) width = 3;
  //   styles.logo.width = `${width}in`;
  // }
  if (logo) {
    let width = (logo.width / logo.height) * 1;
    if (width > 3) width = 3;
    styles.logo.width = `${width}in`;
    styles.logo.maxHeight = 0.9 * 72; // Convert inches to points (72 points per inch)
  }

  return (
    <View style={[styles.headerContainer, customStyles]}>
      {/* Top Header Section */}
      <View style={styles.topHeaderBox}>
        {/* Left side with logo and title */}
        <View style={styles.topHeaderLeft}>
          {/* Logo section */}
          <View style={styles.logoSection}>
            <Image
              src={logo ? logo.url : "/img/LONG_COLOR_ONTRANSPARENT_LOGO.png"}
              style={styles.logo}
            />
          </View>

          {/* Title section */}
          <View style={styles.titleSection}>
            <Text style={getTitleStyle()}>{getPageTitle()}</Text>
            <View style={styles.rowContainer}>
              {/* Left side: Name */}
              <View style={styles.leftColumn}>
                <Text style={styles.dateText}>
                  <Text style={{ fontWeight: "bold" }}>From:</Text> {smartTruncate(addSpaceAfter(projectJSON.subcontractor?.name, 15), 35)}
                </Text>
              </View>

              {/* Right side: Dates */}
              <View style={styles.rightColumn}>
                <View style={styles.row}>
                  <Text style={styles.label}>Application Date</Text>
                  <Text style={styles.value}>{applicationDate}</Text>
                </View>
                <View style={styles.row}>
                  <Text style={styles.label}>Period to Date</Text>
                  <Text style={styles.value}>{periodTo}</Text>
                </View>
              </View>
            </View>
          </View>
        </View>

        {/* Right side with application number */}
        <View style={styles.topHeaderRight}>
          <Text style={styles.applicationLabel}>Application</Text>
          <Text style={styles.applicationNumber}>
            #{application.sequenceNumber}
          </Text>
          <View style={styles.developByContainer}>
            <Text style={styles.singleLineText}>
              Developed by{" "}
              <Text style={{ fontWeight: "bold", fontStyle: "italic" }}>
                PAYearned
              </Text>
              <Text style={{ fontWeight: "normal" }}>.com</Text>
            </Text>
          </View>
        </View>
      </View>

      {/* Project Information Section - Always visible */}
      {!showFullContractorInfo && (
        <View style={styles.projectSection}>
          <Text style={styles.projectHeader}>PROJECT</Text>

          <View style={styles.projectInfoRow}>
            {/* Name + Project # */}
            <View style={styles.projectInfoItem}>
              <Text style={styles.projectLabel}>Name: </Text>
              <Text style={styles.projectValue}>
                {smartTruncate(projectJSON.name, 40)}
              </Text>
            </View>
            <View style={styles.projectInfoItem}>
              <Text style={styles.projectLabel}>Project #: </Text>
              <Text style={[styles.projectValue, { fontWeight: "bold" }]}>
                {smartTruncate(projectJSON.projectId, 40)}
              </Text>
            </View>
          </View>

          <View style={styles.projectInfoRow}>
            {/* Address */}
            <View style={styles.projectInfoItem}>
              <Text style={styles.projectLabel}>Address: </Text>
              <Text style={styles.projectValue}>
                 {smartTruncate(projectJSON?.addressLine1, 40)}
              </Text>
            </View>
            <View style={styles.projectInfoItem}>
              <Text style={styles.projectLabel}>Address 2: </Text>
              <Text style={styles.projectValue}>
                {smartTruncate(projectJSON.addressLine2, 40)}
              </Text>
            </View>
          </View>

          <View style={styles.projectInfoRow}>
            {/* City, State + Zip */}
            <View style={styles.projectInfoItem}>
              <Text style={styles.projectLabel}>City, State: </Text>
              <Text style={styles.projectValue}>
                {smartTruncate(`${projectJSON.city}, ${projectJSON.state}`, 40)}
              </Text>
            </View>
          </View>
          <View style={styles.projectInfoRow}>
            <View style={styles.projectInfoItem}>
              <Text style={styles.projectLabel}>Zip: </Text>
              <Text style={styles.projectValue}>
                {smartTruncate(projectJSON.zip, 40)}
              </Text>
            </View>
          </View>
        </View>
      )}
      {pdfType === "changeOrder" ? (
        <View style={styles.typeInfo}>
          <Text style={styles.typeLegendAesterick}>* </Text>
          <Text style={styles.typeLegendItem}>A = Addition </Text>
          <Text style={styles.typeLegendItem}>R = Revised </Text>
        </View>
      ) : (
        <View />
      )}

      {/* Full Contractor Information Section - Only for application type */}
      {showFullContractorInfo && (
        <View style={styles.contractorSection}>
          {/* Project Column */}
          <View style={styles.contractorColumn}>
            <Text style={styles.contractorHeader}>PROJECT</Text>

            <View style={styles.infoRow}>
              <Text style={styles.infoValue}>
                  {smartTruncate(addSpaceAfter(projectJSON?.name), 66)}
              </Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Project #</Text>
              <Text style={[styles.infoValue, { fontWeight: "bold" }]}>
                {smartTruncate(projectJSON.projectId, 22)}
              </Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Address</Text>
              <Text style={styles.infoValue}>
                {smartTruncate(projectJSON.addressLine1, 22)}
              </Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Address</Text>
              <Text style={styles.infoValue}>
                {smartTruncate(projectJSON.addressLine2, 22)}
              </Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>City, State</Text>
              <Text style={styles.infoValue}>
                {smartTruncate(`${projectJSON.city}, ${projectJSON.state}`, 22)}
              </Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Zip</Text>
              <Text style={styles.infoValue}>
                {smartTruncate(projectJSON.zip, 22)}
              </Text>
            </View>
          </View>

          {/* General Contractor Column */}
          <View style={styles.contractorColumn}>
            <Text style={styles.contractorHeader}>GENERAL CONTRACTOR</Text>

            <View style={styles.infoRow}>
              <Text style={styles.infoValue}>
                {smartTruncate(addSpaceAfter(projectJSON.generalContractor?.name, 33),66)}
              </Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Address</Text>
              <Text style={styles.infoValue}>
                {/* {smartTruncate(projectJSON.generalContractor?.addressLine1, 24)} */}
                {smartTruncate(projectJSON.generalContractor?.addressLine1, 22)}
              </Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Address</Text>
              <Text style={styles.infoValue}>
                {smartTruncate(projectJSON.generalContractor?.addressLine2, 22)}
              </Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>City, State</Text>
              <Text style={styles.infoValue}>
                {smartTruncate(
                  `${projectJSON.generalContractor?.city}, ${projectJSON.generalContractor?.state}`,
                  22
                )}
              </Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Zip</Text>
              <Text style={styles.infoValue}>
                {smartTruncate(projectJSON.generalContractor?.zip, 22)}
              </Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Phone</Text>
              <Text style={styles.infoValue}>
                {smartTruncate(projectJSON.generalContractor?.phoneNumber, 22)}
              </Text>
            </View>
          </View>

          {/* Subcontractor Column */}
           <View style={styles.contractorColumnLast}>
            <Text style={styles.contractorHeader}>SUBCONTRACTOR</Text>

            <View style={styles.infoRow}>
              <Text style={styles.infoValue}>
               {smartTruncate(addSpaceAfter(projectJSON.subcontractor?.name),66)}
              </Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Address</Text>
              <Text style={styles.infoValue}>
                {smartTruncate(projectJSON.subcontractor?.addressLine1, 22)}
              </Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Address</Text>
              <Text style={styles.infoValue}>
                {smartTruncate(projectJSON.subcontractor?.addressLine2, 22)}
              </Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>City, State</Text>
              <Text style={styles.infoValue}>
                {smartTruncate(
                  `${projectJSON.subcontractor?.city}, ${projectJSON.subcontractor?.state}`,
                  22
                )}
              </Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Zip</Text>
              <Text style={styles.infoValue}>
                {smartTruncate(projectJSON.subcontractor?.zip, 22)}
              </Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Phone</Text>
              <Text style={styles.infoValue}>
                {smartTruncate(projectJSON.subcontractor?.phoneNumber, 22)}
              </Text>
            </View>
          </View>
        </View>
      )}
    </View>
  );
}